import React from 'react';

import { Descriptions, Typography } from 'antd';
import { formatDate } from '../helpers/formatDate';
import { IProps } from '../types';

function RepoHeader({
  name,
  type,
  successDate,
  url,
  projectsNum,
  activeProjectsNum,
  lastError,
  projectErrors,
  isDisabled,
}: IProps) {
  return (
    <Descriptions
      title={`${name.toLocaleUpperCase()} - Repository`}
      column={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 }}
    >
      <Descriptions.Item label="Type">
        <Typography.Text strong>{type}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Url">
        <Typography.Link
          href={url}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
        >
          {url}
        </Typography.Link>
      </Descriptions.Item>
      <Descriptions.Item label="Projects">
        <Typography.Text strong>{projectsNum}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Active projects">
        <Typography.Text strong>{activeProjectsNum}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Last successful run" span={2}>
        <Typography.Text strong>{formatDate(successDate)}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Projects with Errors">
        {isDisabled ? (
          <Typography.Paragraph strong type="danger">
            Disabled
          </Typography.Paragraph>
        ) : (
          <Typography.Text strong>{projectErrors}</Typography.Text>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Last Error" span={2}>
        <Typography.Paragraph
          type={lastError ? 'danger' : 'success'}
          ellipsis={{
            rows: 2,
            expandable: 'collapsible',
            onExpand: (e: any) => {
              e.stopPropagation();
            },
          }}
        >
          {lastError ?? 'No Errors'}
        </Typography.Paragraph>
      </Descriptions.Item>
    </Descriptions>
  );
}

export default RepoHeader;
